<template>
  <div class="flex items-center font-medium">
    <!-- Icon wrapper -->
    <div class="mr-1 w-8 text-center">
      <component
        :is="value.permalink ? 'a' : 'div'"
        :href="value.permalink || null"
        :title="value.name"
        class="coin-page"
      >
        <component
          :is="imageComponent"
          :src="value.icon"
          :alt="value.symbol.text"
          :text="value.symbol.text"
          class="h-5 ml-auto mr-auto"
          @error="catchIconError"
        />
      </component>
    </div>
    <!-- Text -->
    <component
      :is="value.permalink ? 'a' : 'div'"
      :href="value.permalink || null"
      class="text-black font-medium coin-page"
    >
      <span>{{ value.name }}</span>
    </component>
  </div>
</template>

<script>
export default {
  name: 'CoinsNameCell',
  components: {
    AvatarInitials: () => import('@/components/avatar-initials'),
  },
  props: {
    /**
     * The required cell data.
     * Required values: { name, symbol, icon }
     * Optional values: { permalink }
     */
    value: {
      type: Object,
      required: true,
      validator(value) {
        return 'symbol' in value && 'name' in value
      },
    },
  },
  data() {
    return {
      iconError: false,
    }
  },
  computed: {
    imageComponent() {
      return this.iconError ? 'AvatarInitials' : 'img'
    },
  },
  methods: {
    catchIconError() {
      this.iconError = true
    },
  },
}
</script>
